/* Daza Organic · vista de la rejilla de productos (cuántos por fila).
   El visitante elige columnas con los botones de la barra de filtros; la
   elección se guarda por tipo de pantalla (escritorio ≥990 / móvil-tableta)
   y se aplica como data-vista-d / data-vista-m sobre <collection-component>,
   que no se vuelve a pintar al filtrar (la rejilla sí). El ancho de cada
   tarjeta lo resuelve el CSS (daza-collection.css). Aquí solo se guarda la
   elección y se ajusta `sizes` de las imágenes para que, con menos columnas,
   el navegador pida una imagen más grande y no salga borrosa. */
(function () {
  'use strict';

  var CLAVE = 'daza-vista';
  var escritorio = window.matchMedia('(min-width:990px)');

  function leer() {
    try { return JSON.parse(localStorage.getItem(CLAVE)) || {}; } catch (e) { return {}; }
  }
  function guardar(obj) {
    try { localStorage.setItem(CLAVE, JSON.stringify(obj)); } catch (e) { /* sin almacenamiento */ }
  }

  function iniciar() {
    var barra = document.querySelector('.s-vista:not([data-listo])');
    var comp = document.querySelector('collection-component');
    if (!barra || !comp) return;
    barra.dataset.listo = '1';

    var defD = parseInt(barra.dataset.defD, 10) || 4;
    var defM = parseInt(barra.dataset.defM, 10) || 2;
    var elegido = leer();

    function valor(tipo) {
      var v = parseInt(comp.dataset[tipo === 'd' ? 'vistaD' : 'vistaM'], 10);
      return v || (tipo === 'd' ? defD : defM);
    }

    function ajustarSizes() {
      var nd = valor('d'), nm = valor('m');
      var sizes = '(min-width:1300px) ' + Math.round(1300 / nd) + 'px, (min-width:990px) ' +
        Math.round(100 / nd) + 'vw, ' + Math.round(100 / nm) + 'vw';
      document.querySelectorAll('#product-grid img[sizes]').forEach(function (img) {
        if (!img.dataset.sizesOrig) img.dataset.sizesOrig = img.getAttribute('sizes');
        img.setAttribute('sizes', sizes);
      });
    }

    function pintar() {
      var tipo = escritorio.matches ? 'd' : 'm';
      var actual = valor(tipo);
      barra.querySelectorAll('.s-vista__btn').forEach(function (b) {
        b.setAttribute('aria-pressed', String(parseInt(b.dataset.cols, 10) === actual));
      });
    }

    if (elegido.d) comp.dataset.vistaD = elegido.d;
    if (elegido.m) comp.dataset.vistaM = elegido.m;

    barra.addEventListener('click', function (e) {
      var b = e.target.closest('.s-vista__btn');
      if (!b) return;
      var tipo = escritorio.matches ? 'd' : 'm';
      var n = parseInt(b.dataset.cols, 10);
      comp.dataset[tipo === 'd' ? 'vistaD' : 'vistaM'] = n;
      elegido[tipo] = n;
      guardar(elegido);
      pintar();
      ajustarSizes();
    });

    escritorio.addEventListener('change', pintar);

    var contenedor = document.getElementById('ProductGridContainer');
    if (contenedor && 'MutationObserver' in window) {
      new MutationObserver(ajustarSizes).observe(contenedor, { childList: true });
    }

    barra.hidden = false;
    pintar();
    if (elegido.d || elegido.m) ajustarSizes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
